import { PanelResultDetails } from "../../store/slices/order/types";
import ResultValue from "./ResultValueComponent";
import TestResultRanges from "./TestResultRanges";
import { ResultValueType } from "../../enums/result-value-type.enum";
import CultureResult from "./CultureResult";
import { RenderRichText } from "../base";
import GreenBall from "../../assets/img/result/green-ball.svg";
import OrangeBall from "../../assets/img/result/orange-ball.svg";
import { getPanelResulItemStatus } from "../../utils/result.utils";
import { ResultStatus } from "../../enums/resultStatus.enum";

const MobileTestResult = ({
  resultDetails,
}: {
  resultDetails: PanelResultDetails;
}) => {
  const resultStatus = getPanelResulItemStatus(resultDetails);
  return (
    <div className="lg:hidden">
      {resultDetails.valueType === ResultValueType.Culture ? (
        <CultureResult resultDetails={resultDetails} />
      ) : (
        <div className="text-[0.87rem] py-2 px-3 rounded-sm bg-white my-8">
          <div className="flex flex-col items-center justify-between mb-4">
            <p className="font-bold"> Test Name</p>
            {/* <p className="pl-4 text-center">{resultDetails?.name}</p> */}
            <div className="flex items-center">
              {resultStatus === ResultStatus.Good ? (
                <img src={GreenBall} alt="green dot icon" className="w-3 h-3" />
              ) : resultStatus === ResultStatus.Abnormal ? (
                <img
                  src={OrangeBall}
                  alt="orange dot icon"
                  className="w-3 h-3"
                />
              ) : null}
              <div className="text-center mx-2 text-[15px] font-[500]">
                <RenderRichText content={resultDetails?.name} />
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center justify-between mb-4">
            <p className="font-bold">Result Value</p>{" "}
            <p className="text-center">
              <ResultValue resultDetails={resultDetails} />
            </p>
          </div>
          {resultDetails?.maxValue && resultDetails?.maxValue && (
            <div className="flex flex-col items-center justify-center">
              <p className="mb-4 font-bold">Test Range</p>
              <TestResultRanges resultDetails={resultDetails} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MobileTestResult;
